<div class="flex items-center gap-2 p-1 bg-gray-100 dark:bg-gray-700 rounded-lg">
  <button
    (click)="switchView('table')"
    [class.bg-white]="currentView === 'table'"
    [class.text-primary-600]="currentView === 'table'"
    [class.dark:bg-gray-800]="currentView === 'table'"
    [class.dark:text-primary-400]="currentView === 'table'"
    [class.text-gray-600]="currentView !== 'table'"
    [class.dark:text-gray-400]="currentView !== 'table'"
    class="p-1.5 rounded-md transition-all duration-200 hover:bg-white dark:hover:bg-gray-800 ripple"
    title="Table View"
  >
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
    </svg>
  </button>
  <button
    (click)="switchView('list')"
    [class.bg-white]="currentView === 'list'"
    [class.text-primary-600]="currentView === 'list'"
    [class.dark:bg-gray-800]="currentView === 'list'"
    [class.dark:text-primary-400]="currentView === 'list'"
    [class.text-gray-600]="currentView !== 'list'"
    [class.dark:text-gray-400]="currentView !== 'list'"
    class="p-1.5 rounded-md transition-all duration-200 hover:bg-white dark:hover:bg-gray-800 ripple"
    title="List View"
  >
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
    </svg>
  </button>
</div>
